module.exports = __webpack_public_path__ + "envMaps/radiance_negy_5.png";